export const locale = {
  lang: 'de',
  data: {
    MENU: {
      HOME: 'Dashboard',
      SAMPLE: 'Api Dokumentation'
    }
  }
}
